module.exports = __webpack_public_path__ + "img/bg_mine_top.210204cd.png";